import Render from './render';

export default function AddToCart() {
	const addButtons = document.querySelectorAll('.js-add-to-cart');

	if (addButtons.length) {
		addButtons.forEach(function (addButton) {
			addButton.addEventListener('click', function () {
				const id = addButton.getAttribute('data-id');
				const qty = addButton.parentNode.querySelector('select').value;

				if (id && qty) {
					const addButtonText = addButton.querySelector('.text');
					const addButtonLoader = addButton.querySelector('.loader');
					const addButtonSuccess = addButton.querySelector('.success');

					addButton.disabled = true;
					addButtonText.classList.add('hidden');
					addButtonLoader.classList.remove('hidden');

					fetch('/api/add-to-cart', {
						method: "POST",
						headers: {
							'Accept': 'application/json',
							'Content-Type': 'application/json'
						},
						body: JSON.stringify({
							id: id,
							qty: qty
						})
					})
						.then(function(response) {
							if (response.ok) {
								addButtonLoader.classList.add('hidden');
								addButtonSuccess.classList.remove('hidden');

								addButton.parentNode.querySelector('select').selectedIndex = 0;

								new Render();

								setTimeout(() => {
									addButtonSuccess.classList.add('hidden');
									addButtonText.classList.remove('hidden');
									addButton.disabled = false;
								}, 3000);
							}
						});
				}
			});
		});
	}
}
